import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";
import ReasonModal from "../ReasonModal";
import {
  AddCircle,
  ArrowDown,
  CloseCircle,
  DocumentDownload,
  Edit,
  Edit2,
  Eye,
  Mobile,
  ProfileAdd,
  ShoppingCart,
  TickCircle,
  Trash,
} from "iconsax-react";
import moment from "moment/moment";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import CustomPagination from "../../Utils/CustomPagination";
import LogModal from "./LogModal";
import { useLoader } from "../../Loader";
import RejectModal from "./RejectModal";

function List(props) {
  const [cerList, setcerList] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const { startLoader, stopLoader } = useLoader();
  const [showLogModal, setShowLogModal] = useState(false);
  const [currentLog, setCurrentLogs] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };

  const permissions = [
    {
      approve: "cer.HOD_approve",
      reject: "cer.HOD_reject",
      titleA: "HOD Approval",
      titleR: "HOD Reject",
      status: "1",
    },
    {
      approve: "cer.CEO_approve",
      reject: "cer.CEO_reject",
      titleA: "CEO Approval",
      titleR: "CEO Reject",
      status: "2",
    },
    {
      approve: "cer.CFO_approve",
      reject: "cer.CFO_reject",
      titleA: "CFO Approval",
      titleR: "CFO Reject",
      status: "3",
    },
    {
      approve: "cer.Finance_approve",
      reject: "cer.Finance_reject",
      titleA: "Finance Approval",
      titleR: "Finance Reject",
      status: "4",
    },
  ];

  const renderPermissionButtons = (row) =>
    permissions
      .filter((perm) => perm.status == row.status)
      .map((perm, index) => (
        <React.Fragment key={index}>
          {utils.hasPermission(primaryMenuRes, "CER", perm.approve) && (
            <RB.Button
              className="btn-flat me-1"
              title={`${perm.titleA}`}
              onClick={handleApprove(row)}
            >
              <TickCircle />
            </RB.Button>
          )}
          {utils.hasPermission(primaryMenuRes, "CER", perm.reject) && (
            <RB.Button
              className="btn-flat me-1"
              title={`${perm.titleR}`}
              onClick={handleReject(row)}
            >
              <CloseCircle />
            </RB.Button>
          )}
        </React.Fragment>
      ));

  const columns = [
    {
      name: "CER No.",
      selector: (row, index) => row.cer_no,
    },
    {
      name: "Plant",
      selector: (row, index) => row.plant_name,
    },
    {
      name: "Location",
      selector: (row, index) => row.location_name,
    },
    {
      name: "Division",
      selector: (row, index) => row.division,
    },
    {
      name: (
        <div>
          CER Logs <br />
        </div>
      ),
      cell: (row) => (
        <>
          <RB.Button
            className="btn-flat me-1"
            title="View"
            onClick={handleLogView(row)}
          >
            <Eye />
          </RB.Button>
        </>
      ),
    },
    {
      name: "Status",
      selector: (row, index) => row.status_label,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <RB.Button
            className="btn-flat me-1"
            title="Delete"
            onClick={handleView(row)}
          >
            <Eye />
          </RB.Button>
          {utils.hasPermission(primaryMenuRes, "CER", "cer.edit") && (
            <>
              {row?.status == "1" && (
                <RB.Button
                  className="btn-flat ms-1"
                  title="Edit"
                  onClick={handelEdit(row)}
                >
                  <Edit2 />
                </RB.Button>
              )}
            </>
          )}
          {utils.hasPermission(primaryMenuRes, "CER", "cer.delete") && (
            <>
              {row?.status == "1" && (
                <RB.Button
                  className="btn-flat ms-1"
                  title="Delete"
                  onClick={showDelete(row)}
                >
                  <Trash />
                </RB.Button>
              )}
            </>
          )}
          {renderPermissionButtons(row)}
        </>
      ),
    },
  ];

  const handleLogView = useCallback((row) => async () => {
    setCurrentLogs(row.cer_log);
    setShowLogModal(true);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleReject = useCallback((row) => async () => {
    setSelectedOrder(row);
    setShowRejectModal(true);
  });

  useEffect(() => {
    getCerList();
  }, [page]);

  const getCerList = () => {
    startLoader();
    utils
      .callAPI("get", `cer/list?page=${page}&per_page=${countPerPage}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setcerList(res);
          stopLoader();
          // setFilter(false)
        } else {
          setcerList([]);
          stopLoader();
        }
      })
      .catch((err) => {
        setcerList([]);
        stopLoader();
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/cer/delete?id=${row?.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getCerList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleApprove = useCallback((row) => async () => {
    startLoader();
    var bodyFormData = new FormData();
    bodyFormData.append("cer_id", row.id);
    bodyFormData.append("status", "accept");
    bodyFormData.append("reject_reason", "");

    utils
      .callAPI("post", `/cer/change-status`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          getCerList();
          stopLoader();
        } else {
          getCerList();
          stopLoader();
        }
      })
      .catch((err) => {
        getCerList();
        stopLoader();
      });
  });

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow ">
          <div className="floating-btns-holder-artisan">
            {utils.hasPermission(primaryMenuRes, "CER", "cer.create") && (
              <a
                href
                className="btn btn-dark btn-circle"
                variant="dark"
                onClick={handleAddClick}
              >
                <AddCircle />
              </a>
            )}
          </div>
          <RB.Card.Header>
            <h4></h4>
            <div className="card-header-action"></div>
          </RB.Card.Header>
          <RB.Card.Body>
            {utils.hasPermission(primaryMenuRes, "CER", "cer.view") && (
              <>
                <DataTable
                  columns={columns}
                  data={cerList.result}
                  highlightOnHover
                  responsive
                  pagination
                  paginationServer
                  paginationTotalRows={cerList.total}
                  paginationPerPage={countPerPage}
                  paginationComponentOptions={{
                    noRowsPerPage: true,
                  }}
                  paginationComponent={() => (
                    <CustomPagination
                      currentPage={page}
                      totalRows={cerList.total}
                      rowsPerPage={countPerPage}
                      onPageChange={handlePageChange}
                    />
                  )}
                  striped
                  onChangePage={(page) => setPage(page)}
                  persistTableHead
                  customStyles={{
                    head: {
                      style: {
                        fontSize: "0.875rem", // Adjust the font size as needed
                        fontWeight: "bold", // Adjust the font weight as needed
                      },
                    },
                  }}
                  // subHeader
                  // subHeaderComponent={subHeaderComponent}
                />
              </>
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
      <LogModal
        show={showLogModal}
        onHide={() => setShowLogModal(false)}
        logs={currentLog}
      />
      <RejectModal
        show={showRejectModal}
        onHide={() => setShowRejectModal(false)}
        onReject={handleReject}
        selectedOrder={selectedOrder}
        getPurchaseOrder={getCerList}
      />
    </>
  );
}

export default List;
